<script>
    import LoadingGif from "$/images/loading-cat-jerry.gif";
</script>

<div class="container">
    <h2 class="message">
        <slot></slot>
    </h2>

    <img class="loading-gif" src={LoadingGif} alt="Loading..." />
</div>

<style>
    @import "../../main.css";

    .container {
        @apply my-auto flex w-full max-w-full flex-col items-center justify-center !important;
    }

    .message {
        @apply reset max-w-3xl text-center text-2xl;
    }

    .loading-gif {
        @apply mt-4 h-40;
    }
</style>
